import { render, staticRenderFns } from "./ORowFormComp.vue?vue&type=template&id=c71c88fe&"
import script from "./ORowFormComp.vue?vue&type=script&lang=js&"
export * from "./ORowFormComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports